import type { FC } from 'react'
import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import UncoverKeyMomentsImage from './UncoverKeyMomentsImage'

const copy = {
  heading: `Uncover key moments in the care journey that impact retention and health outcomes`,
}

const link = {
  text: `Explore Connections`,
  url: `/product/connections/`,
}

const feature = [
  {
    head: `Collect`,
    description: `See the complete view of your patient or member by unifying data across web, mobile web, apps, support and offline interactions.`,
  },
  {
    head: `Understand`,
    description: `Identify traits of your patients and members and uncover key triggers along the care journey that impact engagement, retention and health outcomes.`,
  },
  {
    head: `Centralize`,
    description: `Centralize and scale access to high-quality, secure data and deliver it to the tools and internal teams that need it.`,
  },
]

const UncoverKeyMoments: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <StyledSectionBase variant="2Col">
      <SectionContents>
        <UncoverKeyMomentsImage alt={`Illustration: ${copy.heading}`} />
      </SectionContents>
      <StyledCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <ColumnTrackWrapper>
            <ColumnTrack gap="small">
              {feature.map((feature) => (
                <FeatureBoxBase key={feature.head} alignment="left">
                  <FeatureBox.Body>
                    <FeatureBox.Title>{feature.head}</FeatureBox.Title>
                    <FeatureBox.Text>{feature.description} </FeatureBox.Text>
                  </FeatureBox.Body>
                </FeatureBoxBase>
              ))}
            </ColumnTrack>
          </ColumnTrackWrapper>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </StyledCopy>
    </StyledSectionBase>
  )
}

export default UncoverKeyMoments

const SectionContents = styled(Section.Contents)`
  margin: auto 0;
`

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
    align-self: center;
  }
`

const ColumnTrackWrapper = styled.div`
  padding-top: 40px;
`
